import React from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from '../data/translations';
import { CheckCircle2 } from 'lucide-react';

export const About = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const isRTL = language === 'ar';

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-teal-600/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className={isRTL ? 'lg:order-2' : ''}>
            <h2 className={`text-4xl sm:text-5xl font-bold text-white mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
              {t.about.title}
            </h2>
            <p className={`text-lg text-gray-300 leading-relaxed mb-8 ${isRTL ? 'text-right' : 'text-left'}`}>
              {t.about.content}
            </p>

            {/* Key Points */}
            <div className="space-y-4">
              {[
                language === 'en' ? 'Heritage since 2011' : 'إرث منذ 2011',
                language === 'en' ? 'Six diverse business divisions' : 'ستة أقسام تجارية متنوعة',
                language === 'en' ? 'Commitment to excellence' : 'التزام بالتميز',
                language === 'en' ? '100% Qatari brand' : 'علامة قطرية 100%'
              ].map((point, index) => (
                <div key={index} className={`flex items-center gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
                  <CheckCircle2 className="w-6 h-6 text-teal-400 flex-shrink-0" />
                  <span className="text-gray-300">{point}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Visual Element */}
          <div className={`relative ${isRTL ? 'lg:order-1' : ''}`}>
            <div className="relative aspect-square rounded-2xl overflow-hidden">
              {/* Placeholder for company image/logo */}
              <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-900 backdrop-blur-sm flex items-center justify-center border border-teal-500/20">
                <div className="text-center p-8">
                  <div className="relative w-40 h-40 mx-auto mb-8 p-4 bg-gradient-to-br from-gray-800/50 to-black/50 rounded-2xl border-2 border-teal-500/40 backdrop-blur-sm">
                    <img 
                      src="/rafan-logo.png" 
                      alt="Rafan Group" 
                      className="w-full h-full object-contain drop-shadow-[0_0_15px_rgba(20,184,166,0.6)]"
                    />
                    <div className="absolute inset-0 bg-teal-500/10 rounded-2xl"></div>
                    {/* Glow effect */}
                    <div className="absolute inset-0 bg-gradient-to-br from-teal-400/20 to-transparent rounded-2xl blur-xl"></div>
                  </div>
                  <div className="text-3xl font-bold text-white mb-2">2011 - Present</div>
                  <div className="text-xl text-teal-400">{language === 'en' ? '15+ Years Experience' : '15+ عاماً خبرة'}</div>
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute top-0 left-0 w-full h-full">
                <div className="absolute top-4 left-4 w-24 h-24 border-4 border-teal-400/60 rounded-tl-2xl"></div>
                <div className="absolute bottom-4 right-4 w-24 h-24 border-4 border-teal-400/60 rounded-br-2xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};